// extracted by mini-css-extract-plugin
export var brand = "_2h-9";
export var button = "_2h-0";
export var chevron = "_2h-v";
export var chevronButton = "_2h-w";
export var content = "_2h-n";
export var danger = "_2h-g";
export var dangerOutlined = "_2h-h";
export var dark = "_2h-l";
export var darkTheme = "_2h-c";
export var extraSmall = "_2h-4";
export var fullWidth = "_2h-8";
export var ghost = "_2h-d";
export var gray = "_2h-t";
export var icon = "_2h-p";
export var iconButton = "_2h-s";
export var iconButtonBorder = "_2h-x";
export var iconButtonBorderDark = "_2h-y";
export var iconButtonBorderLight = "_2h-z";
export var iconLeft = "_2h-q";
export var iconRight = "_2h-r";
export var large = "_2h-1";
export var light = "_2h-m";
export var medium = "_2h-2";
export var micro = "_2h-5";
export var nano = "_2h-7";
export var outlined = "_2h-k";
export var pending = "_2h-a";
export var primary = "_2h-i";
export var shadow = "_2h-o";
export var small = "_2h-3";
export var solidLight = "_2h-e";
export var solidLightBrand = "_2h-f";
export var spinner = "_2h-u";
export var transparent = "_2h-j";
export var warning = "_2h-b";
export var wideNano = "_2h-6";